module.exports = __webpack_public_path__ + "static/media/logo.edff5da6.svg";